module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container push-top"
  }, [(_vm.documents === false) ? _c('loading-indicator') : _vm._e(), _vm._v(" "), (_vm.documents.length > 0) ? _c('div', {
    staticClass: "columns"
  }, [(!_vm.search) ? _c('h2', {
    staticClass: "column is-8 is-pulled-left"
  }, [_vm._v(_vm._s(_vm.$t('proposals.drafts')))]) : _vm._e(), _vm._v(" "), (_vm.search) ? _c('h2', {
    staticClass: "column is-8 is-pulled-left"
  }, [_vm._v(_vm._s(_vm.$t('proposals.search_results')))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "column is-4"
  }, [_c('div', {
    staticClass: "search-wrapper"
  }, [_c('div', {
    staticClass: "searchbox is-pulled-right"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    attrs: {
      "type": "search",
      "id": "search",
      "placeholder": _vm.$t('search.placeholder')
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "toggle is-pulled-right"
  }, [_c('a', {
    class: {
      'is-active': _vm.showGallery
    },
    attrs: {
      "title": "Grid Layout"
    },
    on: {
      "click": function($event) {
        _vm.showGallery = true
      }
    }
  }, [_c('i', {
    staticClass: "icon icon-toggle-blocks"
  })]), _vm._v(" "), _c('a', {
    class: {
      'is-active': !_vm.showGallery
    },
    attrs: {
      "title": "List Layout"
    },
    on: {
      "click": function($event) {
        _vm.showGallery = false
      }
    }
  }, [_c('i', {
    staticClass: "icon icon-toggle-list"
  })])])])]) : _vm._e(), _vm._v(" "), (_vm.documents !== false && _vm.documents.length <= 0) ? _c('div', [_c('div', {
    staticClass: "columns"
  }, [(!_vm.search) ? _c('h2', {
    staticClass: "column is-12"
  }, [_vm._v(_vm._s(_vm.$t('proposals.drafts')))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.documents && _vm.u.where(_vm.documents, {
    status: 'draft'
  }).length < 1) ? _c('div', [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-12"
  }, [_c('div', {
    staticClass: "create-new-proposal"
  }, [_c('a', {
    staticClass: "button is-primary is-outlined",
    on: {
      "click": function($event) {
        _vm.Events.$emit('modalOpen', 'newDocumentModal')
      }
    }
  }, [_c('i', {
    staticClass: "icon icon-add"
  })])])])])]) : _vm._e(), _vm._v(" "), (_vm.documents && _vm.search) ? _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-12"
  }, [_c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "hidden"
    }
  }, [(_vm.documents && _vm.showGallery) ? _c('ul', {
    staticClass: "proposal-cards"
  }, _vm._l((_vm.filteredDocuments), function(document) {
    return (_vm.search) ? _c('document-card', {
      key: document.id,
      attrs: {
        "payload": document
      },
      on: {
        "delete": _vm.deleteDocument
      }
    }) : _vm._e()
  })) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "hidden"
    }
  }, [(_vm.documents && !_vm.showGallery) ? _c('ul', {
    staticClass: "proposal-line-items"
  }, _vm._l((_vm.filteredDocuments), function(document) {
    return (_vm.search) ? _c('document-line-item', {
      key: document.id,
      attrs: {
        "payload": document
      },
      on: {
        "delete": _vm.deleteDocument
      }
    }) : _vm._e()
  })) : _vm._e()])], 1)]) : _vm._e(), _vm._v(" "), (_vm.documents && !_vm.search) ? _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-12"
  }, [_c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "hidden"
    }
  }, [(_vm.documents && _vm.showGallery) ? _c('ul', {
    staticClass: "proposal-cards"
  }, _vm._l((_vm.u.where(_vm.documents, {
    status: 'draft'
  })), function(document) {
    return _c('document-card', {
      key: document.id,
      attrs: {
        "payload": document
      },
      on: {
        "delete": _vm.deleteDocument
      }
    })
  })) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "hidden"
    }
  }, [(_vm.documents && !_vm.showGallery) ? _c('ul', {
    staticClass: "proposal-line-items"
  }, _vm._l((_vm.u.where(_vm.documents, {
    status: 'draft'
  })), function(document) {
    return _c('document-line-item', {
      key: document.id,
      attrs: {
        "payload": document
      },
      on: {
        "delete": _vm.deleteDocument
      }
    })
  })) : _vm._e()])], 1)]) : _vm._e(), _vm._v(" "), (_vm.documents) ? _c('hr', {
    staticClass: "proposals-break"
  }) : _vm._e(), _vm._v(" "), (_vm.documents) ? _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-12"
  }, [_c('form', {
    staticClass: "propsal-filter is-pulled-right",
    attrs: {
      "name": ""
    }
  }, [_c('span', {
    staticClass: "filter-by"
  }, [_vm._v(_vm._s(_vm.$t('filters.filter_by')) + " ")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "options": _vm.filterTeamMemberOptions,
      "placeholder": _vm.$t('filters.team_filter_options.everyone'),
      "track-by": "id",
      "label": "name",
      "searchable": false,
      "showLabels": false
    },
    model: {
      value: (_vm.filterTeamMember),
      callback: function($$v) {
        _vm.filterTeamMember = $$v
      },
      expression: "filterTeamMember"
    }
  }), _vm._v(" "), _c('multiselect', {
    attrs: {
      "options": _vm.filterStatusOptions,
      "placeholder": _vm.$t('filters.status_filter_options.all_statuses'),
      "track-by": "value",
      "label": "label",
      "searchable": false,
      "showLabels": false
    },
    model: {
      value: (_vm.filterStatus),
      callback: function($$v) {
        _vm.filterStatus = $$v
      },
      expression: "filterStatus"
    }
  }), _vm._v(" "), _c('multiselect', {
    attrs: {
      "options": _vm.filterDateOptions,
      "placeholder": _vm.$t('filters.date_filter_options.all_time'),
      "track-by": "value",
      "label": "label",
      "searchable": false,
      "showLabels": false
    },
    model: {
      value: (_vm.filterDate),
      callback: function($$v) {
        _vm.filterDate = $$v
      },
      expression: "filterDate"
    }
  })], 1), _vm._v(" "), (_vm.documents) ? _c('h2', {
    staticClass: "is-pulled-left"
  }, [_vm._v(_vm._s(_vm.$t('proposals.sent_proposals')))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.documents && _vm.sentCount < 1) ? _c('div', [_vm._m(1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-12"
  }, [_c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "hidden"
    }
  }, [(_vm.documents && _vm.showGallery) ? _c('ul', {
    staticClass: "proposal-cards"
  }, _vm._l((_vm.filterByStatus(['sent', 'viewed', 'pending', 'signed', 'expired'])), function(document) {
    return (_vm.sentCount > 0) ? _c('document-card', {
      key: document.id,
      attrs: {
        "payload": document
      },
      on: {
        "delete": _vm.deleteDocument
      }
    }) : _vm._e()
  })) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "hidden"
    }
  }, [(_vm.documents && !_vm.showGallery) ? _c('ul', {
    staticClass: "proposal-line-items"
  }, _vm._l((_vm.filterByStatus(['sent', 'viewed', 'pending', 'signed', 'expired'])), function(document) {
    return (_vm.sentCount > 0) ? _c('document-line-item', {
      key: document.id,
      attrs: {
        "payload": document
      },
      on: {
        "delete": _vm.deleteDocument
      }
    }) : _vm._e()
  })) : _vm._e()])], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "icon icon-search"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-12"
  }, [_c('div', {
    staticClass: "no-proposals-sent"
  }, [_c('p', [_vm._v("Nothing to see here ... :(")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0f2cd811","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/Documents.vue
// module id = 505
// module chunks = 0